import { createContext } from "react";

export type WidgetContextValue = { boardId: string; widgetId: string } | undefined;

export const WidgetContext = createContext<WidgetContextValue>(undefined);
